import Alert from '../../components/Alert'
import {
  useState
} from 'react'
import { syncOrders } from '../../apis'
import { BsCheckCircle } from 'react-icons/bs'
import { MdError } from 'react-icons/md'

const SyncSap = () => {
  const [ loading, setLoading ] = useState<boolean>(false)
  const [ orderIds, setOrderIds ] = useState<string>('')
  const [ inValid, setInValid ] = useState<boolean>(false)
  const [ responseMsg, setResponseMsg ] = useState<String>('')
  const [ showAlert, setShowAlert ] = useState<boolean>(false)

  const onSubmitSync = async () => {
    setShowAlert(false)
    setInValid(false)

    if (!orderIds) {
      setInValid(true)
      return
    }
    const orderNos = orderIds?.split(',').filter(id => id).map(id => id.trim())
    if (orderNos.length === 0) {
      setInValid(true)
      return
    }

    if (orderNos.length > 10) {
      setInValid(true)
      return
    }
    
    setLoading(true)
    const { success, message } = await syncOrders(orderNos)
    setInValid(!success)
    setResponseMsg(message!)
    setLoading(false)
    setShowAlert(true)
  }

  return <div className="container px-3">
    <h4 className='font-bold '>Sync Order from SAP</h4>
    <div className='flex flex-col'>
      <label className='inline-block mt-3 '>กรอกเลข Order</label>
      <textarea placeholder="Order No." className={`mt-2 input-form-text ${inValid ? ' border-red-500':''}`}
        value={orderIds} onChange={(e) => setOrderIds(e.currentTarget.value)}
        disabled={loading} />
      <small className="text-muted">
        แบ่งเลข Order ด้วย , เช่น 90000001,90000002 (จำกัด Sync ครั้งละไม่เกิน 10 Order)
      </small>
    </div>
    <div className='flex flex-col items-center justify-center '>
      <button className="px-12 btn-success" onClick={onSubmitSync} disabled={loading}>
        {loading ? 'Syncing...':'Sync'}
      </button>
      <Alert
        onClose={() => setShowAlert(false)}
        show={showAlert}
        dismissible={true}
        variant={inValid ? 'danger' : 'success'}
        styles='mt-3'
      >
        <div className='flex gap-3'>{
          inValid ? <MdError color="red" size={25}/> : <BsCheckCircle color="green" size={25}/>
        } {responseMsg}
        </div>
      </Alert>
    </div>
  </div>
}

export default SyncSap